import { useTranslation } from 'react-i18next'
import Frame from '../layout/Frame'
import { Helmet } from 'react-helmet-async'
import { generatePageTitle } from '../../util'
import k from '../../i18n/keys'
import { UniContainer } from '../common/uni/layout'
import LoadingIndicator from '../common/LoadingIndicator'
import React from 'react'

export const RouteLoading = () => {
  const { t } = useTranslation()
  return (
    <Frame>
      <Helmet>
        <title>{generatePageTitle(t(k.LOADING), t(k.THESSA))}</title>
      </Helmet>
      <UniContainer $wide $marginBlock>
        <LoadingIndicator />
      </UniContainer>
    </Frame>
  )
}
